var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-episode"},[_c('episode-form',{attrs:{"is-voice":_vm.article.content_model === 'voice'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }